import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { BrandLogo } from '../../../components/BrandLogo';
import { areaOrigin } from '../../../helpers/areaLinks';
import { useT } from '../../../i18n/I18nProvider';
import { LocaleSelect } from '../../../i18n/LocaleSelect';
import { LinkButton } from '../../../ui/atoms/LinkButton';

/**
 * Public site header (after prototype@c0c19a1 `app/public-home.tsx`): sticky,
 * the brand as the home link, the language select and "Entrar" to the hub
 * login. The prototype's section nav and cart wait for the pages behind them.
 * The actions wrap under the brand rather than overflow 320 px (WCAG 1.4.10).
 */
export function PublicHeader() {
  const { t } = useT();
  const hub = areaOrigin('hub');

  return (
    <header className="sticky top-0 z-20 border-b border-base-300 bg-base-100">
      <div className="mx-auto flex min-h-16 w-full max-w-6xl flex-wrap items-center justify-between gap-x-4 gap-y-2 px-4 py-2">
        <Link to="/" className="rounded-field">
          <BrandLogo />
        </Link>
        <div className="flex items-center gap-2">
          <LocaleSelect className="w-32" />
          {hub && (
            <LinkButton variant="primary" size="sm" href={`${hub}/login`}>
              {t('public.header:login')}
              <ArrowRight aria-hidden="true" className="h-4 w-4" />
            </LinkButton>
          )}
        </div>
      </div>
    </header>
  );
}
